import React, { createContext, useContext, useEffect, useState, useRef } from 'react';
import { RefreshToken } from '../actions';

const TimerContext = createContext();

const REFRESH_INTERVAL = 15 * 60;

export const TimerProvider = ({ children }) => {

    const [timeLeft, setTimeLeft] = useState(() => {
        const savedTime = localStorage.getItem('timeLeft');
        return savedTime ? JSON.parse(savedTime) : REFRESH_INTERVAL;
    });

    const [isActive, setIsActive] = useState(true);
    const oldToken = localStorage.getItem("token");

    const callApiRef = useRef(null);

    const callApi = async () => {
        if (oldToken) {
            console.log("Refreshing Token...");
            try {
                const result = await RefreshToken();
            } catch (error) {
                console.error("Failed to refresh token", error);
            }
        }
    };

    useEffect(() => {
        callApiRef.current = callApi;
    });

    useEffect(() => {
        let interval = null;

        if (isActive) {
            interval = setInterval(() => {
                setTimeLeft((prev) => {
                    // Save to local storage
                    const newTime = prev > 0 ? prev - 1 : 0;
                    localStorage.setItem('timeLeft', JSON.stringify(newTime));
                    return newTime;
                });
            }, 1000);
        }

        return () => clearInterval(interval);
    }, [isActive]); 


    useEffect(() => {
        if (timeLeft === 0) {
            if (callApiRef.current) callApiRef.current();

            resetTimer();
        }
    }, [timeLeft]); 


    const resetTimer = () => {
        setTimeLeft(REFRESH_INTERVAL);
        localStorage.setItem('timeLeft', JSON.stringify(REFRESH_INTERVAL));
        setIsActive(true);
    };

    const formatTime = (time) => {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    };

    const toggleTimer = () => {
        setIsActive(prev => !prev);
    };

    return (
        <TimerContext.Provider value={{ timeLeft, formatTime, toggleTimer, resetTimer, isActive }}>
            {children}
        </TimerContext.Provider>
    );
};

export const useTimer = () => {
    return useContext(TimerContext);
};